import axiosIns from '@/libs/axios'

const ROOT_URL = '/edges/quick-gain'
const RESCAN_URL = '/edges/rescan-defaults'

export default {
  namespaced: true,
  state: {
    result: null,
    loading: false,
    rescanDefaults: null,
    detailResult: null,
    detailLoading: false,
    dataSave: { message: null, status: null },
  },
  getters: {
    result: s => s.result,
    loading: s => s.loading,
    topResults: s => (s.result ? s.result.topResults : []),
    config: s => (s.result ? s.result.config : null),
    summary: s => (s.result ? s.result.summary : null),
    rescanDefaults: s => s.rescanDefaults,
    detailResult: s => s.detailResult,
    detailLoading: s => s.detailLoading,
    dataSaveStatus: s => s.dataSave,
  },
  mutations: {
    SET_RESULT(state, data) { state.result = data },
    SET_LOADING(state, val) { state.loading = val },
    SET_RESCAN_DEFAULTS(state, data) { state.rescanDefaults = data },
    SET_DETAIL_RESULT(state, data) { state.detailResult = data },
    SET_DETAIL_LOADING(state, val) { state.detailLoading = val },
    SET_DATA_SAVE(state, data) { state.dataSave = data },
  },
  actions: {
    runScan({ commit }, body) {
      commit('SET_LOADING', true)
      commit('SET_RESULT', null)
      return axiosIns.post(ROOT_URL, body)
        .then(response => {
          commit('SET_RESULT', response.data.data)
          commit('SET_LOADING', false)
          const r = response.data.data
          commit('SET_DATA_SAVE', {
            status: true,
            message: `${r.topResults.length} öneri / ${r.summary.passed} geçti / ${r.summary.total} toplam`,
          })
        })
        .catch(error => {
          console.error(error)
          commit('SET_LOADING', false)
          const msg = error?.response?.data?.message || 'Quick Gain başarısız.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
        })
    },
    clearResult({ commit }) {
      commit('SET_RESULT', null)
    },

    // ─── Auto-rescan defaults ──────────────────────────────────────────────
    getRescanDefaults({ commit }, kind = 'QUICK_GAIN') {
      return axiosIns.get(`${RESCAN_URL}/${kind}`)
        .then(response => {
          commit('SET_RESCAN_DEFAULTS', response.data.data)
        })
        .catch(error => {
          // 404 normal — config henüz yok
          if (error?.response?.status !== 404) console.error(error)
          commit('SET_RESCAN_DEFAULTS', null)
        })
    },
    saveRescanDefaults({ commit, dispatch }, body) {
      return axiosIns.post(RESCAN_URL, body)
        .then(response => {
          commit('SET_DATA_SAVE', { status: true, message: 'Otomatik tarama parametreleri kaydedildi.' })
          dispatch('getRescanDefaults', body.kind)
          return response.data.data
        })
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'Kaydetme başarısız.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
          throw error
        })
    },
    toggleRescanEnabled({ commit, dispatch }, { kind, enabled }) {
      return axiosIns.patch(`${RESCAN_URL}/toggle`, { kind, enabled })
        .then(response => {
          commit('SET_DATA_SAVE', { status: true, message: response.data.message })
          dispatch('getRescanDefaults', kind)
        })
        .catch(error => {
          console.error(error)
          commit('SET_DATA_SAVE', { status: false, message: 'Durum değiştirilemedi.' })
        })
    },
    triggerRescan({ commit, dispatch }, kind = 'QUICK_GAIN') {
      return axiosIns.post(`${RESCAN_URL}/${kind}/trigger`)
        .then(response => {
          commit('SET_DATA_SAVE', { status: true, message: response.data.message })
          dispatch('getRescanDefaults', kind)
          return response.data.data
        })
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'Rescan tetiklenemedi.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
          throw error
        })
    },
    applyTpSlRecommendation({ commit, dispatch }, kind = 'QUICK_GAIN') {
      return axiosIns.post(`${RESCAN_URL}/${kind}/tp-sl-apply`)
        .then(response => {
          commit('SET_DATA_SAVE', { status: true, message: response.data.message })
          dispatch('getRescanDefaults', kind)
          return response.data.data
        })
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'TP/SL önerisi uygulanamadı.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
          throw error
        })
    },
    removeRescanDefaults({ commit }, kind = 'QUICK_GAIN') {
      return axiosIns.delete(`${RESCAN_URL}/${kind}`)
        .then(() => {
          commit('SET_RESCAN_DEFAULTS', null)
          commit('SET_DATA_SAVE', { status: true, message: 'Otomatik tarama silindi.' })
        })
        .catch(error => {
          console.error(error)
          commit('SET_DATA_SAVE', { status: false, message: 'Silme başarısız.' })
        })
    },

    // ─── Detail backtest (re-run for selected fırsat) ──────────────────────
    loadDetail({ commit, getters }, item) {
      commit('SET_DETAIL_LOADING', true)
      commit('SET_DETAIL_RESULT', null)
      const { config } = getters
      const body = {
        engineKey: item.engineKey,
        symbol: item.symbol,
        timeframe: item.timeframe,
        market: config ? config.market : 'FUTURES',
        candleLimit: 1500,
        runtimeConfig: {
          tpPerc: config ? config.tpPerc : undefined,
          slPerc: config ? config.slPerc : undefined,
          leverage: config ? config.leverage : undefined,
          commissionPerSide: config ? config.commissionPerSide : undefined,
        },
      }
      return axiosIns.post('/indicators/backtest', body)
        .then(response => {
          commit('SET_DETAIL_RESULT', response.data.data)
          commit('SET_DETAIL_LOADING', false)
        })
        .catch(error => {
          console.error(error)
          commit('SET_DETAIL_LOADING', false)
          const msg = error?.response?.data?.message || 'Detay yüklenemedi.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
        })
    },
    clearDetail({ commit }) {
      commit('SET_DETAIL_RESULT', null)
    },
  },
}
